<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <v-toolbar
            dark
            flat
          >
            <v-toolbar-title>Skapa användarkonto</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-tooltip bottom>
            </v-tooltip>
          </v-toolbar>
          <div v-if="validationErrors">
            <v-alert v-for="error in validationErrors.errors" :key="error">
              {{ error}}
            </v-alert>
          </div>
          <v-card-text>
            <v-form>
              <v-text-field
                label="Användarnamn"
                name="username"
                type="text"
                v-model="username"
                required
                outlined
              ></v-text-field>

              <v-text-field
                label="E-post"
                name="email"
                type="text"
                v-model="email"
                required
                outlined
              ></v-text-field>

              <v-text-field
                label="Lösenord"
                name="password"
                type="password"
                v-model="password"
                required
                outlined
              ></v-text-field>

              <v-text-field
                id="password_confirmation"
                label="Bekräfta lösenord"
                name="password_confirmation"
                type="password"
                v-model="password_confirmation"
                required
                outlined
              ></v-text-field>

            </v-form>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="registerUser">Skicka</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import SweetAlert from '@/services/SweetAlert'

export default {
  data () {
    return {
      email: '',
      password: '',
      password_confirmation: '',
      username: '',
      validationErrors: []
    }
  },

  methods: {
    ...mapActions(['registerAction']),
    // Will call the API and return the result
    registerUser () {
      const userDetails = {
        email: this.email,
        password: this.password,
        password_confirmation: this.password_confirmation,
        username: this.username,
        keycode: this.keycode
      }
      this.registerAction(userDetails)
        .then(() => {
          this.$router.push('/')
          this.resetForm()
          SweetAlert.successfulRegistration()
        })
        .catch(result => {
          console.log(result.response.data.error.errors)
          this.validationErrors = result.response.data.error.errors
          this.$router.push('/register')
          SweetAlert.failureRegistration(result.response.data.error.errors)
        })
    },
    // Not used atm
    getErrorForField (field) {
      const errors = this.validationErrors
      if (errors === 'undefined' || (!errors && !errors.length)) {
        return false
      }
      const filteredList = errors[field]

      if (filteredList && filteredList.length) {
        return filteredList[0]
      }
    }
  }
}
</script>
